import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-criminal-proceed-form',
  templateUrl: './criminal-proceed-form.component.html',
  styleUrls: ['./criminal-proceed-form.component.css']
})
export class CriminalProceedFormComponent implements OnInit {
  title="Add Criminal Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/criminal-proceedings/criminal-proceed-form/criminal-proceed-form.component.ts